import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import { FC, useState } from 'react';
import styled from 'styled-components';
import publicAPI from 'utils/publicAxiosInstance';

const Form = styled.form`
  width: min(90%, 20rem);
  margin-top: 0.5rem;
  & > p {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  a {
    display: flex;
    margin-top: 0.375rem;
    color: var(--primary-700);
    font-weight: 700;
    font-size: 0.9rem;
    &:hover {
      text-decoration: underline;
    }
  }

  button {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    padding: 0.7rem 1.1rem;
  }
`;

const Sent = styled.p`
  margin-top: 0.375rem !important;
  color: #32d583;
  font-size: 0.9rem;
  b {
    font-size: 0.9rem;
  }
`;

const ForgottenPassword: FC = () => {
  const [state, setState] = useState({
    email: '',
    sent: false,
    sentAddress: '',
    error: '',
  });
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    setLoading(true);
    publicAPI
      .post('/auth/forgotten-password', {
        email: state.email,
      })
      .then(() => {
        setLoading(false);
        setState({ ...state, sent: true, sentAddress: state.email, error: '' });
      })
      .catch((err) => {
        setLoading(false);
        if (
          err.response?.data?.fields?.length &&
          err.response.data.fields.includes('email')
        ) {
          setState({
            ...state,
            error: "Aucun compte n'est lié à cette adresse email.",
            sent: false,
          });
        } else {
          setState({
            ...state,
            error: 'Une erreur est survenue.',
            sent: false,
          });
        }
      });
  };

  return (
    <AuthenticationLayout
      title="Mot de passe oublié"
      subtitle="Renseignez votre adresse email pour réinitialiser votre mot de passe"
      backTo="/authentication/login"
      src_image="/logo_institut_principal.png"
    >
      <Form onSubmit={handleSubmit}>
        {state.error && <Error>{state.error}</Error>}
        <Input
          type="email"
          value={state.email}
          label="Adresse email"
          onChange={handleChange}
          name="email"
          required
        />
        {state.sent && (
          <Sent>
            Un email de récupération a été envoyé à l'adresse{' '}
            <b>{state.sentAddress}</b>
          </Sent>
        )}
        <Button color="primary" loading={loading}>
          {state.sent
            ? 'Renvoyer un nouveau lien'
            : 'Réinitialisation du mot de passe'}
        </Button>
      </Form>
    </AuthenticationLayout>
  );
};

export default ForgottenPassword;
